<template>
    <v-row
        no-gutters
        class="mb-auto"
        :class="{ 'ash-bg': !!selectedMessage }"
    >
        <v-col v-if="!selectedMessage">
            <v-list
                id="emailChain"
                ref="emailChain"
                three-line
                subheader
                class="overflow-y-auto pt-6"
                height="70vh"
                style="border-radius: 0;"
            >
                <!-- Once we have multiple emails in an email chain, we'll need to add something like this -->
                <v-list-item-group class="white" color="white">
                    <template v-for="message in selectedEmailChain">
                        <v-list-item :key="message.id" color="white" @click="$emit('update:selectedMessage', message)">
                            <v-list-item-avatar color="primary lighten-5 mr-2" style="min-width: 35px" height="35" width="35" class="rounded-circle">
                                <v-img
                                    v-if="message.brand && message.brand.code != 'other'"
                                    alt="sender avatar image"
                                    :src="getBrandIconPath(message.brand.name)"
                                />
                                <v-icon v-else color="#00000066">
                                    mdi-account-outline
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold" v-text="message.from_name"></v-list-item-title>
                                <v-list-item-subtitle class="text--primary" v-text="message.subject" />
                                <!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-list-item-action-text>
                                    {{ new Date(message.created) | moment("MMMM Do, YYYY") }}
                                </v-list-item-action-text>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider
                            :key="message.id"
                            v-if="selectedEmailChain[selectedEmailChain.length - 1].id !== message.id"
                        />
                    </template>
                </v-list-item-group>
            </v-list>
        </v-col>
        <template v-else>
            <v-col cols="12" class="px-3 py-lg-4 px-lg-6 email">
                <v-card
                    width="100%"
                    class="mt-3 mt-lg-0"
                    flat
                    tile
                >
                    <div class="d-flex px-3 py-lg-3 px-lg-6 justify-space-between">
                        <div class="d-flex">
                            <v-avatar color="primary lighten-5 mr-3 mt-1" style="min-width: 35px" height="35" width="35" class="rounded-circle">
                                <v-img
                                    v-if="selectedMessage.brand && selectedMessage.brand.code != 'other'"
                                    alt="sender avatar image"
                                    :src="getBrandIconPath(selectedMessage.brand.name)"
                                />
                                <v-icon v-else color="#00000066">
                                    mdi-account-outline
                                </v-icon>
                            </v-avatar>
                            <h3 class="mt-2 mt-lg-1" :class="{ 'subtitle-1': $vuetify.breakpoint.smAndDown }">
                                {{ selectedMessage.from_name }}
                            </h3>
                        </div>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="showFullscreen = true"
                                    dark icon
                                    color="primary"
                                    class="mt-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>View message in fullscreen</span>
                        </v-tooltip>
                    </div>
                    <v-divider />
                    <div class="d-flex px-2 px-lg-3 email-body">
                        <email-card
                            v-if="selectedMessage.body_cleaned"
                            :message-subject="selectedMessage.subject"
                            :message-body="selectedMessage.text_html"
                            :queries="searchMode ? [search] : []"
                            style="width: 100%"
                            :dialog.sync="showFullscreen"
                        >
                        </email-card>
                        <v-card-text
                            v-else
                            class="grey--text text--lighten-2 py-2"
                            v-text="'Message contains no text.'"
                        />
                    </div>
                    <v-divider />
                    <div class="d-lg-flex py-1 py-lg-3 mx-3 mx-lg-6 justify-space-between">
                        <a
                            href="#"
                            class="font-weight-regular subtitle-2 replies"
                            @click="$emit('show-thread', selectedMessage)"
                        >
                            Thread
                        </a>
                        <v-dialog
                            v-model="dialog"
                            width="500"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <a
                                    href="#"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="font-weight-regular subtitle-2 replies ml-4"
                                >
                                    Forward
                                </a>
                            </template>

                            <v-card>
                                <v-card-title class="headline grey lighten-2">
                                    Select contacts to forward
                                </v-card-title>

                                <v-card-text>
                                    <v-autocomplete
                                        v-model="contactsToForward"
                                        :items="contactsList"
                                        outlined
                                        dense
                                        chips
                                        small-chips
                                        label="Contacts"
                                        multiple
                                        class="mt-4"
                                    >
                                    </v-autocomplete>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="sendEmail(
                                            contactsToForward,
                                            selectedMessage.text_html
                                        )"
                                    >
                                        Forward
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-spacer></v-spacer>
                        <span class="text-capitalize subtitle-2 amber--text">
                            {{ new Date(selectedMessage.created) | moment("MMMM Do, YYYY - h:mma") }}
                        </span>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="selected" class="d-flex mt-5 mt-lg-0 pt-1 pt-lg-0 actionBox">
                <v-badge
                    color="green"
                    class="attachment-badge"
                    :content="attachements.length"
                    v-if="attachements.length"
                >
                    <v-btn
                        dark
                        x-small
                        icon
                        absolute
                        right
                        color="black"
                        class="attach-btn px-1 mt-4 mt-lg-3"
                        @click.stop="attachementDialog = true"
                    >
                        <v-icon large>mdi-attachment</v-icon>
                    </v-btn>
                </v-badge>
                <v-btn
                    v-else
                    icon
                    absolute
                    right
                    color="black"
                    x-small
                    class="attach-btn px-1 mt-4 mt-lg-3"
                    dark
                    @click.stop="attachementDialog = true"
                >
                    <v-icon large>mdi-attachment</v-icon>
                </v-btn>
                <vue-editor
                    class="messageBox"
                    v-model="newMessage"
                ></vue-editor>

                <v-btn
                    icon color="primary"
                    absolute
                    right
                    class="mt-16"
                    @click="sendEmail(
                        [selectedEmail.from_email],
                        newMessage
                    )"
                >
                    <v-icon large>mdi-send</v-icon>
                </v-btn>

                <v-dialog
                    v-model="attachementDialog"
                    transition="dialog-bottom-transition"
                    max-width="900"
                >
                    <v-card>
                        <v-toolbar
                            color="primary"
                            dark
                        >
                            Attachements
                        </v-toolbar>

                        <v-card-text class="pt-4">
                            <input
                                type="file"
                                id="file"
                                ref="file"
                                :disabled="uploadingAttachement"
                                @change="handleAttachementUpload($event)"
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-progress-circular
                                v-if="uploadingAttachement"
                                color="primary"
                            ></v-progress-circular>
                        </v-card-actions>
                        <hr>
                        <v-card-text class="pt-4">
                            <v-chip
                                v-for="(attachement, index) in attachements"
                                :key="attachement.name"
                                class="p-5"
                                close
                                color="primary"
                                outlined
                                @click:close="removeAttachement(index)"
                            >
                                {{ attachement.name }}
                            </v-chip>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </template>
    </v-row>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
    import emailCard from './email-card.vue';
    import emailSender from '../../mixins/send-email.mixin';

    export default {
        mixins: [emailSender],
        props: {
            // eslint-disable-next-line vue/require-default-prop
            selectedEmailChain: Array,
            selectedEmail: {
                tyep: String,
                required: true
            },
            search: {
                required: false,
                default: '',
                type: String,
            },
            searchMode: Boolean,
            onSearch: Boolean,
            selected: Boolean,
            userKaoshiEmail: {
                type: String,
                required: true
            },
            contacts: {
                type: Array,
                required: true
            },
            selectedMessage: Object,
        },
        components: {
            VueEditor,
            emailCard
        },
        data: () => ({
            forwardDialog: false,
            contactsToForward: [],
            dialog: false,
            showFullscreen: false,
        }),
        computed: {
            contactsList: function () {
                var list = []
                this.contacts.forEach(contact => {
                  list.push(contact.email)
                })
                return list
            },
        }
    };
</script>

<style scoped>
#emailChain {
    background-color: #DFDBE5;
    background-image: url('/images/chat-bg.jpg');
}

#emailChain::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #181235;
    background-color: #ffffff;
    border-radius: 10px;
}

#emailChain::-webkit-scrollbar {
    width: 10px;
    background-color: #ffffff;
}

#emailChain::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #181235;
    background-color: #181235;
}

.replies {
    color: #181235 !important
}

.replies:hover {
    text-decoration: underline;
}

.messageBox {
    background-color: #ffffff;
    border: 0;
    width: 100%;
    height: 80px !important;
}

.messageBox >>> .ql-editor {
    min-height: auto !important;
    width: 95%;
}

.messageBox >>> .ql-formats:nth-child(1),
.messageBox >>> .ql-formats:nth-child(4),
.messageBox >>> .ql-formats:nth-child(6),
.messageBox >>> .ql-formats:nth-child(7),
.messageBox >>> .ql-formats:nth-child(8),
.messageBox >>> .ql-formats:nth-child(9) {
  display: none;
}

.attachment-badge {
    position: absolute;
    right: 10px;
    top: -70px;
}

.attach-btn {
    transform: rotate(90deg);
    right: 10px !important;
    z-index: 10;
}

.ash-bg {
    background-color: #f6f6f6;
}

.actionBox {
    background-color: #fff;
}

.actionBox >>> .v-btn--absolute.v-btn--right {
    right: 0;
}

.v-list--three-line .v-list-item {
    background-color: #fff;
}

.email {
    max-height: 42vh
}

.email >>> .v-card {
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%) !important;
    border-radius: 0.5rem;
}

.email-body {
    height: 278px;
}

@media screen and (max-width: 767px) {
    .messageBox >>> .ql-snow.ql-toolbar button {
        width: 26px;
    }

    .email {
        max-height: 100%;
    }

    .email-body {
        height: 315px;
    }

    .attach-btn {
        right: 5px !important;
    }

    .actionBox {
        background-color: transparent;
    }
}
</style>
